import React, { useState } from "react";
import "./Contact.css";
import { motion } from "framer-motion";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://himchatterjee.in/backend/saveMessage.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (result.success) {
        setStatus("✅ Message Sent Successfully!");
        setFormData({ firstName: "", lastName: "", email: "", message: "" });
      } else {
        setStatus("❌ Something went wrong. Try again!");
      }
    } catch (err) {
      setStatus("⚠️ Server error. Please try later.");
    }
  };

  return (
    <div className="contact-container">
      <motion.div 
        className="contact-info"
        initial={{ opacity: 0, x: -50 }} 
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h2>Him Chatterjee</h2>
        <p><b>Mobile No:</b> +91 9816060237</p>
        <p><b>Res. No:</b> 0177-2633136</p>
        <p><b>Email:</b> vc@sirjjuniv.in</p>
        
        <h3>Office Address :</h3>
        <p>Vice-Chancellor<br/>Sir J. J. School of Art, Architecture & Design<br/>(Deemed To Be University Under De-novo Category)<br/>78, Dr. D. N. Road, Fort, Mumbai-400 001.</p>

        <h3>Studio/Res-Address :</h3>
        <p>Village Hiun, P.O. Rouri via Totu<br/>Summerhill-Shangti Seri-Neri Road<br/>Shimla-11, H.P.</p>
      </motion.div>

      <motion.div 
        className="contact-form"
        initial={{ opacity: 0, x: 50 }} 
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h2>Send me a message</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <input 
              type="text" 
              name="firstName" 
              placeholder="First Name *" 
              value={formData.firstName} 
              onChange={handleChange} 
              required
            />
            <input 
              type="text" 
              name="lastName" 
              placeholder="Last Name" 
              value={formData.lastName} 
              onChange={handleChange} 
            />
          </div>

          <input 
            type="email" 
            name="email" 
            placeholder="Email Address *" 
            value={formData.email} 
            onChange={handleChange} 
            required
          />

          <textarea 
            name="message" 
            placeholder="Message *" 
            rows="5" 
            value={formData.message} 
            onChange={handleChange} 
            required
          ></textarea>

          <motion.button 
            whileHover={{ scale: 1.05 }} 
            whileTap={{ scale: 0.95 }} 
            type="submit"
          >
            SEND MESSAGE
          </motion.button>
        </form>
        {status && <p className="status-msg">{status}</p>}
      </motion.div>
    </div>
  );
}

export default Contact;
